angular.module('internal.trainings')
    .directive('internalTrainingHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'trainings/components/training-header/training-header.html',
            controller: 'internalTrainingHeader',
            replace: true
        };
    }])
    .controller('internalTrainingHeader', ['$scope', 'Permissions', function ($scope, Permissions) {
        $scope.getPermission = function (state, variable, method) {
            Permissions[method](state).then(function (access) {
                $scope[variable] = access;
            })
        }
    }])
;